import {useCallback, useState} from 'react';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {TopicModule} from '../../services/pages/channel/channel.client';
import Card from '../common/card';
import styles from './index.less';


interface ExpertProps {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

// eslint-disable-next-line complexity
const SelfTopicExpert = ({
    infos,
    page,
    channelBusinessLine,
}: ExpertProps) => {
    const size = infos.moduleMaxRows || 3;
    const openSize = infos?.moduleOpenRows || 5;
    const [currentIndex, setCurrentIndex] = useState(size);
    const [isFinished, setIsFinished] = useState(false);
    const itemNumber = infos.itemList?.length || 0;

    const arrowClick = useCallback(
        () => {
            if (!isFinished) {
                const index = currentIndex + openSize;
                setCurrentIndex(index);
                (index >= itemNumber) && setIsFinished(true);
            }
        },
        [isFinished, currentIndex, itemNumber]
    );

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        () => {
            if (infos?.moreUrl) {
                const urlParams = {
                    linkUrl: infos?.moreUrl,
                };
                const logParams = {
                    page: page,
                    value: 'jump_zhuanjialiebiao',
                    channelId: infos.channelId,
                    pageType: channelBusinessLine,
                    moduleId: infos.moduleId,
                    moduleName: infos.moduleName,
                };
                navigateToUrl(urlParams, logParams);
            }
        },
        [
            channelBusinessLine,
            infos.channelId,
            infos.moduleId,
            infos.moduleName,
            infos.moreUrl,
            page,
            navigateToUrl,
        ]
    );

    return (
        <div
            className={styles.expertWrap}
            data-show={
                JSON.stringify({
                    'page': page,
                    'value': 'jump_zhuanjialiebiao',
                    'pageSourceId': infos.channelId,
                    'pageType': channelBusinessLine,
                    'valueId': infos.moduleId,
                    'valueTitle': infos.moduleName,
                    'valueType': VALUE_TYPE.MODULE,
                })
            }
        >
            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div
                                onClick={handleClick}
                            >
                                {
                                    infos.moreUrl
                                        ? (
                                            <img
                                                onClick={() => {}}
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }
            {
                itemNumber > 0
                    ? (
                        <div>
                            {
                                infos.itemList?.slice(0, currentIndex).map((item, index) => {
                                    return (
                                        <div
                                            className={styles.cardWrap}
                                            key={item.itemId}
                                            data-show={JSON.stringify({
                                                'page': page,
                                                'value': 'jump_zhuanjialiebiao',
                                                'pageSourceId': infos.channelId,
                                                'pageType': channelBusinessLine,
                                                'valueId': item.itemId,
                                                'valueTitle': item.title,
                                                'valueType': VALUE_TYPE.ITEM,
                                            })}
                                        >
                                            <Card
                                                specInfo={item.fieldValue}
                                                ubcExt={{
                                                    page: page,
                                                    value: 'jump_zhuanjialiebiao',
                                                    pageSourceId: item.channelId,
                                                    pageType: channelBusinessLine ?? '',
                                                    valueId: item.itemId,
                                                    valueTitle: item.title ?? '',
                                                }}
                                            />
                                            {
                                                index < (itemNumber || 1) - 1
                                                    ? <div className={styles.line} />
                                                    : null
                                            }
                                        </div>
                                    );
                                })
                            }
                            {
                                itemNumber > 3 && !isFinished && (
                                    <div
                                        onClick={arrowClick}
                                        className={styles.moreTextWrap}
                                    >
                                        <div className={styles.moreText}>展开更多</div>
                                        <img
                                            src="https://med-fe.cdn.bcebos.com/content-external-channel/more-down.png"
                                            className={styles.arrow}
                                        />
                                    </div>
                                )
                            }
                        </div>
                    )
                    : null
            }
        </div>
    );
};

export default SelfTopicExpert;
